import type { ValueOf } from '@/types/common';

export const EXPORT_FORMAT = {
  PDF: 'pdf',
  CSV: 'csv',
  XLSX: 'xlsx',
  SPREADSHEET: 'spreadsheet',
} as const;

export type ExportFormat = ValueOf<typeof EXPORT_FORMAT>;
